<template>
  <md-card class="md-card-login" :class="{'md-card-hidden': cardHidden}">
    <md-card-content>
      <div class="logo-container">
        <img src="https://res.cloudinary.com/pixel-bucket/image/upload/v1577030508/etax/lris_lhd8ny.gif" alt="logo">
        <h2 class="login-title">Log in to your account</h2>
        <p class="login-subtitle">Welcome back! Please enter your details.</p>
      </div>
      <slot name="form-content"></slot>
    </md-card-content>
    <md-card-actions>
      <slot name="form-actions">
        <div class="auth-links">
          <div class="auth-links--div">
            <router-link to="/forgot-taxid" class="md-simple md-block">
              Forgot {{$constants.identityLabels.ebs}}?
            </router-link>

            <router-link to="/signup" class="md-simple md-block" >
              Forgot Password?
            </router-link>
          </div>
          <p class="first-time-text">
            First time here? <a role="button" class="create-new-lnk" @click="$router.push('/register')">Create New {{$constants.identityLabels.ebs}}</a>
          </p>
        </div>
      </slot>
    </md-card-actions>
    <div class="or"><span>OR</span></div>
    <md-card-actions>
      <md-button class="md-success md-block md-plain md-no-elevation" @click="$router.push({ name: 'tccverification' })">Verify a Tax Clearance Certificate</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "login-card-new",

  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      cardHidden: true,
      payerLogin: {
        name: this.$constants.login.payer,
        path: "/login",
        class: ""
      },
      adminLogin: {
        name: this.$constants.login.admin,
        path: "/admin/login",
        class: ""
      },
      consultantLogin: {
        name: this.$constants.login.consultant,
        path: "/consultant/login",
        class: ""
      }
    };
  },

  beforeMount() {
    setTimeout(this.showCard, 400);
  },

  methods: {
    showCard: function() {
      this.cardHidden = false;
    },

    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },

    openLoginPage(loginType) {
      if(loginType.class === "active") { return; }
      this.$router.push(loginType.path);
    }
  },

  mounted() {
    const routeName = this.$route.name;

    switch (routeName) {
      case this.adminLogin.name:
        this.adminLogin.class = "active";
        break;
      case this.consultantLogin.name:
        this.consultantLogin.class = "active";
        break;
      default:
        this.payerLogin.class = "active";
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-login {
  padding: 20px 0;
  max-width: 100% !important;
  box-shadow: none !important;
  background: transparent !important;
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

.logo-container img {
  height: 48px;
  width: 48px;
}

.login-title {
  color: #181D27;
  font-size: 22px;
  font-weight: 600;
  margin: 12px 0 0px;
}

.login-subtitle {
  color: #535862;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}

.md-card .md-card-actions {
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 0;
  margin-right: 0;
}

:deep(.md-button) {
  text-transform: capitalize;
  font-weight: 500;
  font-size: 0.825rem;
  margin: 0 !important;

  &.md-primary {
    &.md-plain {
      background-color: #F6F2FF !important;
      color: #8A3FFC !important;
      border: 1px solid #8A3FFC !important;

    }
  }
  &.md-success {
    &.md-plain {
      background-color: #E9FFEA !important;
      color: #24A148 !important;
      font-weight: 500;
      font-size: 0.825rem;
      border: 1px solid #24A148 !important;
      text-transform: capitalize;
    }
  }
}

.auth-links {
  width: 100%;

  &--div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  a {
    text-transform: capitalize;
    color: #414141 !important;
    font-size: 13px;
    font-weight: 400;
  }

  .first-time-text {
  text-align: center;
  color: #8D8D8D;
  font-size: 13px;
  font-weight: 400;
  margin: 10px 0 0;
  }

  .create-new-lnk {
    color: #8A3FFC !important;
    font-weight: 500;
    cursor: pointer;
  }
}

.or {
  position: relative;
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
  margin: auto;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background: #8D8D8D;
    top: 11px;
  }

  span {
    padding: 0 8px;
    background: #fff;
    color: #8D8D8D;
    font-weight: 400;
    position: relative;
    z-index: 1;
  }
}
.browser-comp {
  text-align: center;
  font-size: small;
  background-color: #d95260;
  padding-bottom: 0;
}

/* End of Style */

.browser-comp .md-field{
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.browser-comp .md-field::after{
  display: none;
}
</style>
